export const PATCH_WELCOME_PENDING = 'PATCH_WELCOME_PENDING';
export const PATCH_WELCOME_FULFILLED = 'PATCH_WELCOME_FULFILLED';
export const PATCH_WELCOME_REJECTED = 'PATCH_WELCOME_REJECTED';
export const PATCH_TEAM_WELCOME_PENDING = 'PATCH_TEAM_WELCOME_PENDING';
export const PATCH_TEAM_WELCOME_FULFILLED = 'PATCH_TEAM_WELCOME_FULFILLED';
export const PATCH_TEAM_WELCOME_REJECTED = 'PATCH_TEAM_WELCOME_REJECTED';

export default function reducer(state = {
  processed: false,
  teamProcessed: false,
  errors: {},
}, action) {
  switch (action.type) {
    case PATCH_WELCOME_PENDING: {
      return {
        ...state,
        processed: false
      };
    }
    case PATCH_WELCOME_FULFILLED: {
      return {
        ...state,
        processed: true,
      };
    }
    case PATCH_WELCOME_REJECTED: {
      return {
        ...state,
        errors: action.payLoad
      };
    }
    default:
      return {...state};
  }
}
